export const navbarItems = [
  {
    path: "features",
    label: "Tính năng",
  },
  {
    path: "step-to-join",
    label: "Cách tham gia",
  },
  {
    path: "guides",
    label: "Hướng dẫn",
  },
  {
    path: "subscribe",
    label: "Theo dõi",
  },
  {
    path: "https://ungho.f17.gg/", // Updated path to website URL
    label: "Ủng hộ",
    isLink: true,
    isFirstEffect: true
  },
];
